/**
 * Site-wide identity. Edit this file to change the name shown on the Welcome
 * screen, the Start menu header, the IE home page and the mobile fallback.
 */
export const site = {
  /** Shown on the Welcome screen tile and the Start menu header. */
  userName: 'Teon',
  /** Windows account name used in filesystem paths (`C:\Documents and Settings\<here>`). */
  accountName: 'Teon',
  /** Where the Outlook Express contact form sends mail. */
  email: 'me@teon.io',
  domain: 'teon.io',
  url: 'https://teon.io',
  title: 'teon.io',
  tagline: 'A site to occupy my domain.',
  /** Shown on the IE home page under the welcome banner. */
  blurb: 'Very good at starting things.',
  /** Used by the mobile fallback footer and the IE "About" box. */
  copyrightYear: 2026,
} as const;
